import axios from 'axios';

const backendF10Api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_F10_URL,
});

export default backendF10Api;
